import React from 'react';
import { useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiTool } from 'react-icons/fi';

export default function Placeholder() {
  const location = useLocation();
  const pathName = location.pathname.replace('/', '').charAt(0).toUpperCase() + location.pathname.slice(2);

  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-8 bg-slate-50/50">
      <div className="w-16 h-16 bg-slate-100 text-slate-400 rounded-2xl flex items-center justify-center mb-4 border border-slate-200">
        <SafeIcon icon={FiTool} className="text-2xl" />
      </div>
      <h2 className="text-xl font-semibold text-slate-900 mb-2">{pathName || 'Module'} Workspace</h2>
      <p className="text-slate-500 max-w-md">
        This section of the Contribution OS is actively being constructed. It will maintain the same rigorous data structure and premium interface principles established in the core modules.
      </p>
    </div>
  );
}